/**
 * Browser polyfills for Node.js globals
 * This file must be imported FIRST before any other imports
 * to ensure compatibility with libraries that expect Node.js globals.
 */

// Polyfill 'global' for libraries that expect Node.js environment (e.g., React scheduler)
if (typeof global === 'undefined') {
  window.global = globalThis
}

export {}
